import { AtkRobotPage } from "portal/views/autotractor/AtkRobotPage";
import { buildPermission } from "portal/utils/auth";
import { getClass, RobotClass } from "portal/utils/robots";
import { LaserWeederRobotPage } from "portal/views/laserweeder/LaserWeederRobotPage";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { UnauthorizedPage } from "portal/components/UnauthorizedPage";
import { useParams, useSearchParams } from "react-router-dom";
import { withAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import React, { FunctionComponent } from "react";

export enum RobotView {
  LaserWeeder = "laserweeder",
  Atk = "atk",
}

const _AnyRobotPage: FunctionComponent = () => {
  const { serial } = useParams();
  const robotClass = getClass(serial);
  const [searchParams] = useSearchParams();

  switch (robotClass) {
    case RobotClass.Buds:
    case RobotClass.Slayers:
    case RobotClass.Reapers: {
      return <LaserWeederRobotPage />;
    }
    case RobotClass.Rtcs: {
      return <AtkRobotPage />;
    }
    default: {
      // for sims + unknown-class robots, allow the user to switch between the
      // atk and laserweeder views with a query param
      if (searchParams.get("view") === "atk") {
        return <AtkRobotPage offerViewSwitchButton={RobotView.LaserWeeder} />;
      } else {
        return <LaserWeederRobotPage offerViewSwitchButton={RobotView.Atk} />;
      }
    }
  }
};

export const AnyRobotPage = withAuthorizationRequired(
  {
    or: [
      buildPermission(
        PermissionAction.read,
        PermissionResource.robots,
        PermissionDomain.customer
      ),
      buildPermission(
        PermissionAction.read,
        PermissionResource.robots,
        PermissionDomain.all
      ),
    ],
  },
  _AnyRobotPage,
  <UnauthorizedPage />
);
